"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageFiles = void 0;
var classnames_1 = __importDefault(require("classnames"));
var events_1 = require("events");
var react_1 = __importStar(require("react"));
require("./PackageFiles.scss");
var PackageFile_1 = require("./PackageFile");
var log_1 = __importDefault(require("@app/shared/log"));
var initialState = {
    files: []
};
var PackageFiles = /** @class */ (function (_super) {
    __extends(PackageFiles, _super);
    function PackageFiles(props) {
        var _this = _super.call(this, props) || this;
        _this.state = initialState;
        _this.eventEmitter = new events_1.EventEmitter();
        _this.handleExpand = function (file, expandDir) {
            _this.props.onExpand(file, expandDir);
        };
        _this.handleCollapse = function (file) {
            _this.props.onCollapse(file);
        };
        _this.handleSelect = function (filename, isChecked) {
            log_1.default.info(filename + " " + isChecked);
        };
        _this.eventEmitter.on('expand', _this.handleExpand);
        _this.eventEmitter.on('collapse', _this.handleCollapse);
        _this.eventEmitter.on('select', _this.handleSelect);
        return _this;
    }
    PackageFiles.getDerivedStateFromProps = function (nextProps, prevState) {
        return __assign(__assign({}, prevState), { files: nextProps.files });
    };
    PackageFiles.prototype.componentWillUnmount = function () {
        this.eventEmitter.removeAllListeners();
    };
    PackageFiles.prototype.render = function () {
        return (react_1.default.createElement("div", { className: classnames_1.default('card', 'package-files', this.props.className) },
            react_1.default.createElement("div", { className: "card-header" },
                react_1.default.createElement("div", { className: "card-header-title" },
                    react_1.default.createElement("p", null, "Package Contents"))),
            react_1.default.createElement("nav", { className: "panel" }, PackageFile_1.loop(this.state.files, this.eventEmitter, this.props.asperaEnabled, this.props.downloadEnabled, this.props.downloadSizeLimitInMB, this.props.encryptedPackage, this.props.fileStatus, this.props.httpGatewayStatus, this.props.onDownload, this.props.onOpenDownload, this.props.onRetry, this.props.onStop, this.props.packageSize, true))));
    };
    return PackageFiles;
}(react_1.Component));
exports.PackageFiles = PackageFiles;
